var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnassignedProjectsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#2D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 18C29.2311 18 26.5243 18.8211 24.222 20.3594C21.9197 21.8978 20.1253 24.0843 19.0657 26.6424C18.0061 29.2006 17.7288 32.0155 18.269 34.7313C18.8092 37.447 20.1426 39.9416 22.1005 41.8995C24.0584 43.8574 26.553 45.1908 29.2687 45.731C31.9845 46.2712 34.7994 45.9939 37.3576 44.9343C39.9157 43.8747 42.1022 42.0803 43.6406 39.778C45.1789 37.4757 46 34.7689 46 32C46 28.287 44.525 24.726 41.8995 22.1005C39.274 19.475 35.713 18 32 18ZM32 44C29.6266 44 27.3066 43.2962 25.3332 41.9776C23.3598 40.6591 21.8217 38.7849 20.9135 36.5922C20.0052 34.3995 19.7676 31.9867 20.2306 29.6589C20.6936 27.3311 21.8365 25.1929 23.5147 23.5147C25.193 21.8365 27.3312 20.6936 29.6589 20.2306C31.9867 19.7676 34.3995 20.0052 36.5922 20.9134C38.7849 21.8217 40.6591 23.3598 41.9776 25.3332C43.2962 27.3065 44 29.6266 44 32C44 35.1826 42.7357 38.2348 40.4853 40.4853C38.2348 42.7357 35.1826 44 32 44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24H33V35H31V24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 38C31.7033 38 31.4133 38.088 31.1666 38.2528C30.92 38.4176 30.7277 38.6519 30.6142 38.926C30.5006 39.2001 30.4709 39.5017 30.5288 39.7926C30.5867 40.0836 30.7296 40.3509 30.9393 40.5607C31.1491 40.7704 31.4164 40.9133 31.7074 40.9712C31.9983 41.0291 32.2999 40.9993 32.574 40.8858C32.8481 40.7723 33.0824 40.58 33.2472 40.3334C33.412 40.0867 33.5 39.7967 33.5 39.5C33.5 39.1022 33.342 38.7206 33.0607 38.4393C32.7794 38.158 32.3978 38 32 38Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedProjectsIcon);
export default __webpack_public_path__ + "static/media/unassigned_projects_icon.bcf857a6.svg";
export { ForwardRef as ReactComponent };